<template>
  <div>
      <header class='demos-header'>
        <h1 class="demos-title">个人信息修改</h1>
      </header>
      <div class="weui-cells weui-cells_form">
      <div class="weui-cell">
        <div class="weui-cell__hd">
          <label class="weui-label">原始密码：</label>
        </div>
        <div class="weui-cell__bd">
          <input v-model="profileParam.oldPassword" class="weui-input"  type="password" >
        </div>
      </div>
      <div class="weui-cell">
        <div class="weui-cell__hd">
          <label class="weui-label">新密码：</label>
        </div>
        <div class="weui-cell__bd">
          <input v-model="profileParam.password" class="weui-input" type="password" >
        </div>
      </div>
      <div class="weui-cell">
        <div class="weui-cell__hd">
          <label class="weui-label">确认密码：</label>
        </div>
        <div class="weui-cell__bd">
          <input v-model="profileParam.confirmPassword" class="weui-input" type="password" >
        </div>
      </div>
      <div class="weui-cell">
        <div class="weui-cell__hd">
          <label class="weui-label" >真实姓名：</label>
        </div>
        <div class="weui-cell__bd">
          <input v-model="profileParam.trueName" class="weui-input" type="text">
        </div>
      </div>
      <div class="weui-cell">
        <div class="weui-cell__hd">
          <label class="weui-label" >手机号：</label>
        </div>
        <div class="weui-cell__bd">
          <input v-model="profileParam.phone" class="weui-input" type="text">
        </div>
      </div>
      <div class="weui-cell">
        <div class="weui-cell__bd">
          <a href="javascript:void(0);" class="weui-btn weui-btn_primary" @click="handleSubmit">提交</a>
        </div>
      </div>
      <div class="weui-cell">
        <div class="weui-cell__bd">
          <a href="/" class="weui-btn weui-btn_primary">首页</a>
        </div>
      </div>
         <div class="weui-cell">
        <div class="weui-cell__bd">
<a :href="'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxe10f359dcc13cd59&redirect_uri=http%3A%2F%2Fwww.alsaky123.com%2Fapi%2Fwx%2FgetOAuth%3FresultUrl%3Dhttp%3A%2F%2Fwww.alsaky123.com%2Fapi%2Fuser%2Finfocode&response_type=code&scope=snsapi_base&state=null&connect_redirect=1#wechat_redirect'" class="weui-btn weui-btn_primary">获取授权</a>
          <a href="javascript:void(0);" class="weui-btn weui-btn_primary" @click="bangding">授权绑定</a>
        </div>
      </div>
    </div>
     <a-modal title="绑定微信推送" :maskClosable="config.globlaMaskClosable" style="top: 10px;" :width="640"  v-model="receiptVisible"
        @ok="bangdingcheck" destroyOnClose>
        <a-form :form="receiptForm">
       <a-form-item label="ID" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input v-bind:disabled="true"  v-model="receiptMdl.id"  v-decorator="['id', { initialValue: receiptMdl.id, rules: [{ required: false, message: '请输入ID'}]}]" />
            </a-form-item>
          <a-form-item label="姓名" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input v-bind:disabled="true" v-model="receiptMdl.name" v-decorator="['name', { initialValue: receiptMdl.name, rules: [{ required: false, message: '请输入姓名'}]}]" />
            </a-form-item>
          <a-form-item label="手机号码" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
            <a-input v-model="receiptMdl.tell" v-decorator="['tell', { initialValue: receiptMdl.tell, rules: [{ required: false, message: '请输入手机号'}]}]" />
          </a-form-item>
        </a-form>
      </a-modal>

  </div>
</template>

<script>
  import { userModifyPassword,getwxcode,getopenid,userInfo } from '@/api/sys'
   import { updateOpenId,getwxcodekk } from '@/api/basic'
  import { getInfo } from '@/api/login'
  import storage from "@/utils/storage"
  import { showMsg } from '@/utils/util'
  import Bus from '@/layouts/bus'
  import Vue from 'vue'

  export default {
    name: 'profile',
    data() {
      return {
        profileParam:{
          oldPassword:"",      
          password:"",  
          confirmPassword:"",  
          trueName:"",  
          phone:"",  
        },
        receiptMdl: {},
        receiptForm: this.$form.createForm(this),
        receiptVisible:false,

      }
    },
    created () {
      this.loadUserInfo()
    },

    methods: {
      bangding(){
       userInfo({})
        .then(res => {
           if (res.code === '0'){
             var that=this
            Vue.set(that.receiptMdl, 'id', res.data.id)
            Vue.set(that.receiptMdl, 'name', res.data.username)
            Vue.set(that.receiptMdl, 'tell', res.data.phone)
        
           }
        }).catch(() => {
        }).finally(() => {
  
        })
              this.receiptVisible= true;
      },
      bangdingcheck(){
        var that=this
                    getopenid({id:that.receiptMdl.id,phone:that.receiptMdl.tell})
        .then(res => {
          
            that.receiptVisible=false;
           
        }).catch(() => {
        }).finally(() => {
               that.receiptVisible=false;
        })
      },
      handleSubmit () { 
        if (!this.profileParam.oldPassword){
          showMsg('旧密码不能为空',3)
          return    
        }
        if (!this.profileParam.password){
          showMsg('新密码不能为空',3)
          return    
        }
        if (!this.profileParam.confirmPassword){
          showMsg('确认密码不能为空',3)
          return    
        }
        if (this.profileParam.password !== this.profileParam.confirmPassword){
          showMsg('两次输入密码不一致',3)
          return    
        }
        console.log(this.profileParam)
        Bus.$emit('showSpinning', true, "提交中...")
        userModifyPassword(Object.assign({}, this.profileParam))
        .then(res => {
          if (res.code === '0'){
            showMsg("修改成功",3)
          }
        }).catch(() => {
        }).finally(() => {
          Bus.$emit('showSpinning', false)
        })
      },
      loadUserInfo () { 
        getInfo()
        .then(res => {
           if (res.code === '0'){
             this.profileParam.trueName = res.data.trueName
             this.profileParam.phone = res.data.phone
             this.profileParam = Object.assign({}, this.profileParam) 
           }
        }).catch(() => {
        }).finally(() => {
  
        })
      },
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>